var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$store.state.pageTitle))]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }